import { AttributeEditModeConfig } from '@source-components-react/types';

export const attributeEditModeConfigs: AttributeEditModeConfig[] = [
  {
    name: 'video-host-cloud-name',
    heading: 'Video Host Cloud Name',
    subHeading: 'Set the media host cloud name for 3 different device resolutions',
    defaultValues: {},
    // Filled by Video Selector / team defaults — not something marketers edit by hand.
    hiddenToUser: true,
  },
  {
    name: 'video-public-id',
    heading: 'Video Public ID',
    subHeading: 'Set the video public ID for 3 different device resolutions',
    defaultValues: {},
    // Filled by Video Selector — not something marketers edit by hand.
    hiddenToUser: true,
  },
  {
    name: 'video-selector-3-resolutions',
    heading: 'Video Selector',
    subHeading: 'Select a video for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'video-poster-selector-3-resolutions',
    heading: 'Poster Image',
    subHeading: 'Select an uploaded image shown before playback; defaults to the video\'s first frame, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-video-attributes-controls-3-resolutions',
    heading: 'Video Controls',
    subHeading: 'Show the browser playback controls (default "true"; set "false" for background/ambient video), for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-video-attributes-autoplay-3-resolutions',
    heading: 'Video Autoplay',
    subHeading: 'Start playback automatically (browsers require muted "true" for autoplay to work), for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-video-attributes-loop-3-resolutions',
    heading: 'Video Loop',
    subHeading: 'Restart the video automatically when it ends, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-video-attributes-muted-3-resolutions',
    heading: 'Video Muted',
    subHeading: 'Start with the audio muted (required by browsers for autoplay), for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-video-attributes-playsinline-3-resolutions',
    heading: 'Video Plays Inline',
    subHeading: 'Play within the page on mobile instead of forcing fullscreen (default "true"), for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-video-attributes-preload-3-resolutions',
    heading: 'Video Preload',
    subHeading: 'How much to download before playback: "none", "metadata" (default) or "auto", for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-video-attributes-width-3-resolutions',
    heading: 'Video Intrinsic Width',
    subHeading: 'Set the intrinsic pixel width (with height, reserves layout space before the video loads) for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-video-attributes-height-3-resolutions',
    heading: 'Video Intrinsic Height',
    subHeading: 'Set the intrinsic pixel height (with width, reserves layout space before the video loads) for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'video-transformations-3-resolutions',
    heading: 'Video Transformations',
    subHeading: 'Set extra delivery transformations (e.g. "c_fill,ar_16:9"); merged over the defaults q_auto,vc_auto,c_limit,w_1920, for 3 different device resolutions',
    defaultValues: {},
  },
];
